module.exports = __webpack_public_path__ + "img/f1.61f0c0c0.png";